'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _SvgContainer = require('./SvgContainer');
var _SvgContainer2 = _interopRequireDefault(_SvgContainer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ReceiptSharp = function ReceiptSharp(props) {
  return _react2.default.createElement(_SvgContainer2.default, {
    height: props.height,
    width: props.width,
    color: props.color,
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0,
    className: props.className
  }, _react2.default.createElement('svg', {
    style: props.style,
    className: props.cssClasses,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 512 512'
  }, props.title ? _react2.default.createElement('title', null, props.title) : '', _react2.default.createElement('path', {
    d: 'M448 48l-32-16-32 16-32-16-32 16-32-16-32 16-32-16-32 16-48-16v256.05h224V424c0 30.93 33.07 56 64 56h12c30.93 0 52-25.07 52-56V32zM272.5 240l-.5-32h159.5l.5 32zm-64-80l-.5-32h223.5l.5 32z'
  }), _react2.default.createElement('path', {
    d: 'M336 424V320H16v32c0 50.55 5.78 71.62 14.46 87.63C45.19 466.8 71.86 480 112 480h256s-32-20-32-56z'
  })));
};
ReceiptSharp.defaultProps = {
  // style
  style: {},
  color: '#000000',
  height: '22px',
  width: '22px',
  cssClasses: '',
  title: '',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
ReceiptSharp.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  height: _propTypes2.default.string,
  width: _propTypes2.default.string,
  cssClasses: _propTypes2.default.string,
  title: _propTypes2.default.string,
  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,
  // functions
  onClick: _propTypes2.default.func
};
exports.default = ReceiptSharp;
module.exports = exports['default'];